import React from 'react';
import { TopPage } from '@/pages/TopPage';

export const App = () => <TopPage />;
